<template>
  <div class="formate-box">
    <span class="formate-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36.705"
        height="24.475"
        viewBox="0 0 36.705 24.475"
      >
        <path
          d="M34.666-8.46a2.041,2.041,0,0,0-1.16.363L26.514-3.642V-7.453a3.182,3.182,0,0,0-3.3-3.047H3.3A3.182,3.182,0,0,0,0-7.453V10.929a3.182,3.182,0,0,0,3.3,3.047H23.212a3.182,3.182,0,0,0,3.3-3.047V7.117L33.5,11.572a2.043,2.043,0,0,0,3.206-1.644V-6.453A2.018,2.018,0,0,0,34.666-8.46ZM24.474,10.929a1.172,1.172,0,0,1-1.262,1.007H3.3A1.172,1.172,0,0,1,2.04,10.929V-7.453A1.172,1.172,0,0,1,3.3-8.46H23.212a1.172,1.172,0,0,1,1.262,1.007Zm10.2-1L34.6,9.845,26.514,4.7V-1.226l8.158-5.195Z"
          transform="translate(0 10.5)"
        />
      </svg>
    </span>
    <video class="video_tag" :src="url" controls></video>
  </div>
</template>
<script>
export default {
  name: 'videoViewer',
  props: {
    url: {
      type: String,
      required: true,
    },
  },
};
</script>
